import { Box, Card, Typography } from "@mui/material";
import React from "react";
import { OverviewCardData } from "../../../Types/common";

interface MyComponentProps {
    data: OverviewCardData
}

const DashOverviewCards: React.FC<MyComponentProps> = (props) => {
    return (
        <Card
            sx={{
                p: 3,
                borderRadius: 2,
                bgcolor: props.data.color,
                color: "white",
                height: "100%",
                boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)",
            }
            }>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                <Typography variant="h6" > {props.data.title} </Typography>
                {props.data.icon}
            </Box>
            < Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h4" sx={{ mb: 0.5 }}>
                    {props.data.value}
                </Typography>
                {
                    props.data.percentageChange && (
                        <Typography
                            variant="caption"
                            sx={{ display: "flex", alignItems: "center", mt: 1 }
                            }
                        >
                            {props.data.percentageChange > 0 ? "+" : ""}
                            {props.data.percentageChange}%
                        </Typography>
                    )}
            </Box>
            < Box >
                <Typography variant="body2" > {props.data.subText} </Typography>
            </Box>
        </Card>
    );
}

export default DashOverviewCards;
